/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPartners = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm15-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0zM3 9h5.414L12 12.586 15.586 9H21v13h-2v-4h-2v4h-2v-9.586l-3 3-3-3V22H7v-4H5v4H3V9zm2 7h2v-5H5v5zm12-5v5h2v-5h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPartners as Partners };
